export const LS_KEYS = {
  USER: 'TINTIN_USER',
  SETTING: 'TINTIN_SETTING',
  LOG_LEVELS: 'TINTIN_LOG_LEVELS',
} as const
